module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Dedication1"
    }
  }, [_c('p', {
    staticClass: "deda"
  }, [_vm._v("The only thing that frightened me during the entire war, were the periscopes of the German submarines – and the spirit of their crews – unbroken up to the end.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("Winston Churchill")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-631c1aff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Dedication1.vue
// module id = 72
// module chunks = 0